// Module
var code = "<svg width=\"14\" height=\"14\" style=\"fill:#333\" ng-class=\"{'hide': !vm.hasSymbol}\"> <path transform=\"translate(5,5)\"></path> </svg>";
// Exports
module.exports = code;